export default "__VITE_ASSET__DI9NSL5X__"